import {
  CssBaseline,
  LocaleContext,
  Modal as GWCModal,
  ThemeProvider as GWCThemeProvider,
  ThemeProviderProps as GWCThemeProviderProps,
  useTheme,
} from '@gwc/main'
import {useEffect} from 'react'

import {DivProps} from '../../types'
import {deliveryTheme} from './theme'
import {classes} from './ThemeProvider.classes'

type ThemeProviderProps = {
  dir: 'rtl' | 'ltr'
  locale: string
}

export function ThemeProvider({dir, locale, children}: React.PropsWithChildren<ThemeProviderProps>) {
  useEffect(() => {
    document.body.classList.add(classes.noMobilePressEffects)
  }, [])
  return (
    <GWCThemeProvider theme={{...deliveryTheme, dir}} isGlobal>
      <GWCModal.Provider>
        <LocaleContext locale={locale}>
          <CssBaseline />
          {children}
        </LocaleContext>
      </GWCModal.Provider>
    </GWCThemeProvider>
  )
}

type LocalThemeProviderProps = Pick<GWCThemeProviderProps, 'children' | 'theme'> & DivProps

export function LocalThemeProvider(props: LocalThemeProviderProps) {
  const theme = useTheme()

  return <GWCThemeProvider {...props} dir={theme.dir} />
}
